jQuery(document).ready(function ($) {
  // if (window.location.pathname === '/cart') {
  //   window.location.href = '/checkout';
  // }

$(".product__info-slides").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  vertical: true,
  asNavFor: ".product__image-slides",
  arrows: false,
  dots: false,
  infinite: true,
});

$(".product__image-slides").slick({
  slidesToShow: 2,
  slidesToScroll: 1,
  asNavFor: ".product__info-slides",
  centerMode: true,
  arrows: true,
  dots: true,
  infinite: false,
});

let $heroSliderElems = $(".hero__banner-slider .slider__bg");

$(".product__info-slides").on(
  "afterChange",
  function (event, slick, currentSlide) {
    let $currentSlide = $(slick.$slides[currentSlide]);
    let slideColor = $currentSlide.data("slide-color") || "#4F0D13";
    console.log(slideColor);
    $heroSliderElems.css("--slide-color", slideColor);
  }
);

// Initial color set on page load
let initialColor = "#4F0D13";
$heroSliderElems.css("--slide-color", initialColor);
});
